// extracted by mini-css-extract-plugin
export default {"LoadingPlaceholder":"LoadingPlaceholder_LoadingPlaceholder__s7cPO"};